import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { useAlert } from "../../constants/AlertProvider";
import { MODE_ORGANIZER, useMode } from "../../constants/ModeProvider";
import HomeNavbar from "../candidate/HomeNavbar";

const NAV = {
  developer: [
    { to: "/leaderboard", label: "Leaderboard" },
    { to: "/hub", label: "Free Agents" },
    { to: "/submissions", label: "Submissions" },
    { to: "/recruit", label: "Recruit" },
  ],
  organizer: [
    { to: "/leaderboard", label: "Leaderboard" },
    { to: "/organizer", label: "Organizer Tools" },
    { to: "/judging", label: "Judging" },
    { to: "/commissioner", label: "Commissioner" },
  ],
};

// Wraps League pages in the main app chrome (HomeNavbar) so they match the rest
// of the app, then adds a League sub-bar with mode-aware nav and a mode toggle.
export default function DashboardShell({ children }) {
  const { mode, toggleMode } = useMode();
  const showAlert = useAlert();
  const isOrganizer = mode === MODE_ORGANIZER;
  const links = NAV[mode] || NAV.developer;

  const handleToggleMode = () => {
    toggleMode().catch((err) => {
      const detail = err?.response?.data?.detail;
      showAlert(detail || "Couldn't switch modes.", "error");
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <HomeNavbar />
      {/*
        Offset the fixed 64px HomeNavbar. Use an inline style rather than a
        Tailwind class: `pt-16` is only used here, and Tailwind's content
        scan wasn't emitting utilities unique to this file, so the class
        resolved to 0 and the League sub-nav rendered hidden behind the navbar.
      */}
      <div style={{ paddingTop: "4rem" }}>
        <div className="border-b border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800">
          <div className="mx-auto flex max-w-5xl flex-col gap-3 px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
            <nav className="flex gap-6 overflow-x-auto">
              {links.map((link) => (
                <Link
                  key={link.to}
                  className="flex-shrink-0 text-sm font-medium text-gray-600 dark:text-gray-300 transition-colors duration-200 hover:text-blue-600 dark:hover:text-blue-400"
                  to={link.to}
                >
                  {link.label}
                </Link>
              ))}
            </nav>
            <button
              className="w-fit flex-shrink-0 rounded-full border border-blue-200 dark:border-blue-800 px-3 py-1 text-xs font-medium text-blue-600 dark:text-blue-400 transition-colors duration-200 hover:bg-blue-50 dark:hover:bg-blue-900/30"
              type="button"
              onClick={handleToggleMode}
            >
              {isOrganizer ? "Organizer mode" : "Developer mode"} · switch
            </button>
          </div>
        </div>
        <main>{children}</main>
      </div>
    </div>
  );
}

DashboardShell.propTypes = {
  children: PropTypes.node,
};
